<template>
  <div class="intro">
    <div class="intro-content">
      <h1>Cracking the Case</h1>
      <p>Taking down large ORC operations can hinge on the smallest details. Field AP associates and the AP Investigations team must work together closely to gather, document and report potential ORC activity.</p>
      <p><strong>Test your knowledge of ORC operations and processes as the case unfolds.</strong></p>
    </div>
    <router-link to="/intro-video">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import NextButton from '@/components/NextButton.vue'

export default {
  name: 'intro',
  components: {
    NextButton
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .intro {
    background: url('~@/assets/intro-bg.jpg') center center no-repeat;
    background-size: cover;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    text-align: left;
  }

  .intro-content{ 
    width: 320px;
    position: absolute; 
    top: 80px;
    left: 150px;
  }

  p { 
    color: #525252;
    font-size: 19px;
  }
</style>
